import { Box, Typography } from "@mui/material";
import {
  GoogleMap,
  MarkerF,
  InfoWindowF,
  useLoadScript,
} from "@react-google-maps/api";
import React, { memo, useState } from "react";

const SVG_BLACK_ICON = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="40" height="40">
  <circle cx="50" cy="30" r="25" fill="#222" stroke="#555" stroke-width="6" />
  <line x1="50" y1="55" x2="50" y2="80" stroke="#222" stroke-width="6" />
  <path d="M45 80 L50 90 L55 80" fill="#222" />
</svg>
`;

const LocationMap = ({ coordinates, height = 400, zoom = 15, address }) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_KEY,
  });

  const [map, setMap] = React.useState(null);
  const [showInfoWindow, setShowInfoWindow] = useState(false);
  const [mapCenter, setMapCenter] = useState(coordinates);
  const [markerPosition, setMarkerPosition] = useState(coordinates);

  if (loadError) return <Typography>Error loading map</Typography>;
  if (!isLoaded) return <Typography>Loading map...</Typography>;

  if (!coordinates?.lat || !coordinates?.lng) {
    return (
      <Box
        height={height}
        display="flex"
        alignItems="center"
        justifyContent="center"
        border="1px solid #ddd"
      >
        <Typography>No location available</Typography>
      </Box>
    );
  }

  // const onLoad = useCallback((map) => {
  //   const bounds = new window.google.maps.LatLngBounds(coordinates);
  //   map.fitBounds(bounds);

  //   setMap(map);
  // }, []);

  // const onUnmount = useCallback((map) => {
  //   setMap(null);
  // }, []);

  return (
    <Box sx={{ width: "100%", height }}>
      <GoogleMap
        center={mapCenter}
        zoom={zoom}
        // onLoad={onLoad}
        // onUnmount={onUnmount}
        mapContainerStyle={{ width: "100%", height: "100%" }}
        options={{
          zoomControl: true,
          streetViewControl: true,
          mapTypeControl: true,
          fullscreenControl: true,
        }}
      >
        <MarkerF
          position={markerPosition}
          visible={true}
          onMouseOver={() => setShowInfoWindow(true)}
          onMouseOut={() => setShowInfoWindow(false)}
          icon={{
            url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(
              SVG_BLACK_ICON
            )}`,
            scaledSize: new window.google.maps.Size(40, 40),
          }}
        >
          {showInfoWindow && (
            <InfoWindowF
              position={markerPosition}
              
            >
              <div style={{ maxWidth: "200px" }}>
                <Typography variant="body1" fontWeight={600}>
                  {address || coordinates.title || "Location"}
                </Typography>
              </div>
            </InfoWindowF>
          )}
        </MarkerF>
      </GoogleMap>
    </Box>
  );
};

export default memo(LocationMap);
